import { getExerciseTypeVersionAdapter } from '@datacamp/exercise-types';
var exerciseTypeVersionAdapter = getExerciseTypeVersionAdapter('PureMultipleChoiceExercise', 'v3');
export default exerciseTypeVersionAdapter;